import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatINR } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { toggleWishlist, inWishlist } = useCart();
  const discount = product.mrp > product.price
    ? Math.round(((product.mrp - product.price) / product.mrp) * 100)
    : 0;
  const wished = inWishlist(product.id);

  return (
    <div
      className="product-card group relative animate-fade-up"
      style={{ animationDelay: `${(index % 12) * 40}ms` }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/p/${product.id}`} className="block">
        <div className="relative overflow-hidden bg-[#f1f1f1] aspect-[3/4] max-h-[560px]">
          <img
            src={product.images?.[0]}
            alt={product.name}
            loading="lazy"
            className="product-img w-full h-full object-cover"
          />
          {product.tags?.includes("new-drop") && (
            <span className="absolute top-3 left-3 bg-[#FF3B30] text-white text-[10px] font-display tracking-widest px-2 py-1">NEW DROP</span>
          )}
          {discount > 0 && (
            <span className="absolute top-3 right-3 bg-white text-black text-[10px] font-display tracking-widest px-2 py-1 border border-black/30">
              -{discount}%
            </span>
          )}
          {product.collab && (
            <span className="absolute bottom-3 left-3 bg-black text-white text-[10px] font-display tracking-widest px-2 py-1">
              {product.collab}
            </span>
          )}
        </div>
      </Link>

      <button
        onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
        className={`absolute top-3 right-12 w-8 h-8 flex items-center justify-center border ${wished ? "bg-black text-white border-black" : "border-black/40 text-black"} hover-invert opacity-0 group-hover:opacity-100 transition-opacity`}
        aria-label="Wishlist"
        data-testid={`wishlist-btn-${product.id}`}
      >
        <Heart size={14} fill={wished ? "currentColor" : "none"} />
      </button>

      <div className="mt-3 px-1">
        <Link to={`/p/${product.id}`}>
          <h3 className="font-display text-base tracking-tight uppercase">{product.name}</h3>
        </Link>
        <div className="flex items-baseline gap-2 mt-1">
          <span className="text-base font-semibold">{formatINR(product.price)}</span>
          {product.mrp > product.price && (
            <span className="text-xs text-black/40 line-through">{formatINR(product.mrp)}</span>
          )}
        </div>
        <div className="flex gap-1 mt-2 flex-wrap">
          {product.colors?.slice(0, 4).map((c) => (
            <span key={c} className="text-[10px] text-black/40 font-mono uppercase">{c}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
